import React from "react";
import { FaPhone } from 'react-icons/fa';
import { LuBookOpen, LuMessageSquare } from 'react-icons/lu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTwitter, 
  faFacebook, 
  faInstagram, 
  faYoutube, 
  faLinkedin 
} from '@fortawesome/free-brands-svg-icons';
import qualbotTextImage from '../images/Qualbots-logo.png';

export default function Footer() {
  return (
    <footer className="relative bg-gray-300 pt-8 pb-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap">
          <div className="w-full lg:w-2/12 px-4">
            <img
              src={qualbotTextImage}
              alt="QualBot logo"
              className="logo w-80 md:w-65 h-24 md:h-28 object-cover object-center"
            />
          </div>
          <div className="w-full lg:w-4/12 px-4 text-gray-700">
            <h4 className="text-3xl font-semibold">Let's keep in touch!</h4>
            <p className="flex items-center mt-1">
              <FaPhone className="mr-2" /> +254705583722
            </p>
            <p className="flex items-center mt-1">
              <LuMessageSquare className="mr-2" /> info@qualbots-intl.com
            </p>
            <p className="flex items-center mt-1">
              < LuBookOpen className="mr-2" /> KOFISI Karen, 45 Salaam Building, Karen Road. KOFISI Africa
            </p>
            
            <div className="mt-6 flex">
              {[
                { icon: faTwitter, color: "text-blue-400" },
                { icon: faFacebook, color: "text-blue-600" },
                { icon: faYoutube, color: "text-pink-500" },
                { icon: faInstagram, color: "text-pink-500" },
                { icon: faLinkedin, color: "text-blue-700" },
              ].map((social, index) => (
                <button
                  key={index}
                  className={`${social.color} shadow-lg font-normal h-10 w-10 flex items-center justify-center rounded-full outline-none focus:outline-none mr-2`}
                  type="button"
                >
                  <FontAwesomeIcon icon={social.icon} />
                </button>
              ))}
            </div>
          </div>
          <div className="w-full lg:w-6/12 px-4">
            <div className="flex flex-wrap items-top mb-6">
              {[
                {
                  title: "Useful Links",
                  links: [
                    { text: "About Us", href: "https://www.creative-tim.com/presentation" },
                    { text: "Products", href: "https://blog.creative-tim.com" },
                    { text: "Work With Us", href: "https://www.github.com/creativetimofficial" },
                    { text: "Careers", href: "https://www.creative-tim.com/bootstrap-themes/free" },
                  ],
                },
                {
                  title: "Queries",
                  links: [
                    { text: "Consultation", href: "https://www.creative-tim.com/presentation" },
                    { text: "Request Demo", href: "https://blog.creative-tim.com" },
                    { text: "Pricing", href: "https://www.github.com/creativetimofficial" },
                    { text: "Customer Support", href: "https://www.creative-tim.com/bootstrap-themes/free" },
                  ],
                },
                {
                  title: "Other Resources",
                  links: [
                    { text: "Licence", href: "https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md" },
                    { text: "Terms & Conditions", href: "https://creative-tim.com/terms" },
                    { text: "Privacy Policy", href: "https://creative-tim.com/privacy" },
                    { text: "Contact Us", href: "https://creative-tim.com/contact-us" },
                  ],
                },
              ].map((section, index) => (
                <div key={index} className="w-full lg:w-4/12 px-4">
                  <span className="block uppercase text-gray-600 text-sm font-semibold mb-2">
                    {section.title}
                  </span>
                  <ul className="list-unstyled">
                    {section.links.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        <a
                          className="text-gray-700 hover:text-gray-900 font-semibold block pb-2 text-sm"
                          href={link.href}
                        >
                          {link.text}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
        <hr className="my-6 border-gray-400" />
        <div className="flex flex-wrap items-center md:justify-between justify-center">
          <div className="w-full md:w-4/12 px-4 mx-auto text-center">
            <div className="text-sm text-gray-600 font-semibold py-1">
              Copyright © {new Date().getFullYear()} Qualbots-international.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}